import StateView from "./StateView";

// Full-panel failure. Use only when there is no data to show — if rows are
// already on screen and a refetch failed, use ErrorBanner instead.
const ErrorState = ({
  title = "Something went wrong",
  description = "Please check your connection and try again.",
  onRetry,
}) => (
  <StateView
    actionLabel={onRetry ? "Retry" : undefined}
    description={description}
    onAction={onRetry}
    title={title}
    variant="error"
  />
);

export default ErrorState;
